import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { generateReactKey } from 'src/common/helpers/common.helpers';

import {
  InfoBlock,
  InfoBlockContainer,
  InfoElement,
  InfoWrapper,
  InfoWrapperTitle,
} from '../../open-questionnaires-details.styles';

const DeviceInfo = ({
  deviceInfo,
}: {
  deviceInfo: {
    os: string;
    ip: string;
    device: string;
    browser: string;
  };
}) => {
  const { t } = useTranslation('employee');

  return (
    <InfoWrapper>
      <InfoWrapperTitle>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:questionnaire.labels.deviceInformation')}
        </Typography>
      </InfoWrapperTitle>

      <InfoBlock>
        <InfoBlockContainer key={generateReactKey()}>
          {Object.entries(deviceInfo).map(([key, value]) => {
            return (
              <InfoElement key={generateReactKey()}>
                <Typography weight="bold">{`${t(
                  `employee:questionnaire.deviceInformation.labels.${key}`
                )}`}</Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                  {value || '-'}
                </Typography>
              </InfoElement>
            );
          })}
        </InfoBlockContainer>
      </InfoBlock>
    </InfoWrapper>
  );
};

export default DeviceInfo;
